export const distance500OffsetX = "0px";
export const distance500OffsetY = "2px";
export const distance500BlurRadius = "6px";
export const distance500SpreadRadius = "0px";
export const distance500Color = "#767676";
export const distance500Opacity = 0.4;
export const distance600OffsetX = "0px";
export const distance600OffsetY = "4px";
export const distance600BlurRadius = "8px";
export const distance600SpreadRadius = "0px";
export const distance600Color = "#767676";
export const distance600Opacity = 0.4;
export const glowPrimaryOffsetX = "0px";
export const glowPrimaryOffsetY = "0px";
export const glowPrimaryBlurRadius = "8px";
export const glowPrimarySpreadRadius = "0px";
export const glowPrimaryColor = "#247ddc";
export const glowPrimaryOpacity = 0.2;
export const glowDangerOffsetX = "0px";
export const glowDangerOffsetY = "0px";
export const glowDangerBlurRadius = "8px";
export const glowDangerSpreadRadius = "0px";
export const glowDangerColor = "#a72929";
export const glowDangerOpacity = 0.2;